//GeneratorFlag:[NoChange]
import Region from './region';
import City from './city';

export default {Region, City}
export{Region, City}